import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  welcome: 'Welcome',
  inThisCourse: 'In this course',
  lessons: 'Lessons',
  minApprox: 'min. approx.',
  minutes: 'Minutes',
  minute: 'Minute',
  courses: 'Courses',
  readyForIt: 'Get started today',
  daysLeft: (amountOfDays: number) =>
    `${amountOfDays === 1 ? 'Day' : 'Days'} left`,
  lessonsAmount: (amountOfLessons: number) =>
    `${amountOfLessons === 1 ? 'Lesson' : 'Lessons'}`,
  continue: 'Start lesson',
  start: 'Enroll now',
};

const welsh = {
  welcome: 'Croeso',
  inThisCourse: 'Yn y cwrs hwn',
  lessons: 'Gwersi',
  minApprox: 'isaf. amcangyfrif.',
  minutes: 'Munudau',
  minute: 'Munud',
  courses: 'Cyrsiau',
  readyForIt: 'Dechreuwch heddiw',
  daysLeft: (amountOfDays: number) =>
    `${amountOfDays === 1 ? 'Dydd yn ar ôl' : 'Dyddiau yn ar ôl'}`,
  lessonsAmount: (amountOfLessons: number) =>
    `${amountOfLessons === 1 ? 'Gwers' : 'Gwersi'}`,
  continue: 'Dechreuwch y gwers',
  start: 'Cofrestrwch nawr',
};

export const courseHomeText: any = getLocalizationBasedOnLang(english, welsh);
